import { atom } from "recoil";

const KEY = "selected-message-thread";

export const SelectedMessageThreadAtom = atom<number | undefined>({
    key: KEY,
    default: undefined,
});
